var _style, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgMapMark = function SvgMapMark(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgMapMark",
    x: "0px",
    y: "0px",
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    style: {
      enableBackground: "new 0 0 22 22"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgMapMark{fill:#B5B5B5;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1710",
    transform: "translate(-425.81 -1005.8)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1709",
    transform: "translate(404.381 1005.8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1489",
    className: "svgMapMark svgBase svgHover svgSelect",
    d: "M32.4,13.3c-2.6,0-4.6-2.1-4.6-4.6s2.1-4.6,4.6-4.6c2.6,0,4.6,2.1,4.6,4.6c0,0,0,0,0,0 C37.1,11.2,35,13.3,32.4,13.3z M32.4,5.6c-1.7,0-3.1,1.4-3.1,3.1c0,1.7,1.4,3.1,3.1,3.1c1.7,0,3.1-1.4,3.1-3.1 C35.5,7,34.1,5.6,32.4,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1490",
    className: "svgMapMark svgBase svgHover svgSelect",
    d: "M32.4,21.8c-0.4,0-0.8-0.3-0.8-0.8c0-0.2,0.1-0.4,0.2-0.5c2.1-2.2,7.5-8.6,7.5-11.8 c0-3.8-3.1-7-7-7c-3.8,0-7,3.1-7,7c0,0,0,0,0,0c0,1.8,1.8,5,4.9,8.9c0.3,0.3,0.2,0.8-0.1,1.1s-0.8,0.2-1.1-0.1l0,0 c-3.5-4.3-5.3-7.6-5.3-9.8c0-4.7,3.8-8.5,8.5-8.5s8.5,3.8,8.5,8.5c0,4.5-7.6,12.6-7.9,12.9C32.8,21.7,32.6,21.8,32.4,21.8z"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMapMark, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/map_mark.da22a63b.svg";
export { ForwardRef as ReactComponent };